<template>
    <div>RiwayatPersalinanPerkawinan</div>
</template>